// Functions to query the current browser state
define('core/global/state',["jquery"], function ($) {
    console.log("state");
    return {

        //************ GET BREAKPOINT WIDTH ******************
        getBreakpoint : function() {
            var bp;
            bpDoc = document.documentElement.clientWidth;
            bpInner = window.innerWidth; // Use for css pixel
            bp = (typeof bpDoc !== "undefined" && typeof bpInner !== "undefined") ? bpInner : bpDoc;

            return bp;
        },

        //************ IS THIS AN OLD VERSION OF IE ******************
        // Temporary workaround for Swipe.js not working on IE8.
        oldIe : function() {
            return $('html').hasClass('lt-ie9');
        }
    }
});
